module.exports = __webpack_public_path__ + "static/media/icon_pagination_list_level_4.15e1f9ff.svg";